import React, { useEffect, useState } from "react";
import Heading from "../../common/heading/Heading";
import "./Maim.css";
import { useNavigate } from "react-router-dom";

const Maim = ({  }) => {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    setDarkMode(savedMode === "true"); // true or false
  }, []);
  return (
 <>
  {/* الخلفية */}
  <div className={`Maim-background ${darkMode ? "dark-mode" : ""}`}></div>

  {/* إطار الصورة والعناصر الطائرة */}
  <div className={`img-frame2Maim ${darkMode ? "dark-mode" : ""}`}>
    <div className="fly-behind">
      <span className="item pen">✏️</span>
      <span className="item book">📘</span>
      <span className="item pencil">🖋️</span>
      <span className="item paper">📄</span>
    </div>
    <img
      src={darkMode ? "/images/mo/backgroud2.png" : "/images/mo/backgroud2.png"}
      className="imgt2Maim"
      alt="Maim background"
    />
  </div>

  {/* المحتوى */}
  <section className={`hero-content ${darkMode ? "dark-mode" : ""}`}>
    <div className="container">
      <div className="row">
           <Heading
          title={
            <>
              مرحبًا بك في منصة{" "}
              <span className="text-highlight">م/ محمد عبد المنعم</span>
              <br />
              لتعليم اللغة الإنجليزية
            </>
          }
        />
      <br/>    
      <br/>
      <br/>

        <div className="button">
          <button className="primary-btn2" onClick={() => navigate("/Signin")}>
            انضم الآن <i className="fa fa-long-arrow-alt-right"></i>
          </button>
          <button className="secondary-btn2" onClick={() => navigate("/courses")}>
            جميع الكورسات <i className="fa fa-long-arrow-alt-right"></i>
          </button>
        </div>
      </div>

      <div className="flying-elements">
        <span className="book">📚</span>
        <span className="letter">A</span>
        <span className="letter">B</span>
        <span className="letter">C</span>
        <span className="book">📖</span>
        <span className="book">🪶</span>
      </div>
    </div>
  </section>
  <div className="margin"></div>
</>

  );
};

export default Maim;
